import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { RouteStateService } from '../../../core/services/route-state.service';
import { ToastService } from '../../../core/services/toast.service';
import { CustomMenuItem } from '../../../core/models/menu-item.model';
import { TreeNode } from 'primeng/api';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
    selectedTab :string = "";
    // Menu GL
    @Input() itemsGLSetup: CustomMenuItem[];
    @Input() itemsGLInput: CustomMenuItem[];
    @Input() itemsGLProcess: CustomMenuItem[];
    @Input() itemsGLReport: CustomMenuItem[];
    @Input() itemsGLInquiry: CustomMenuItem[];

    // Menu AP
    @Input() itemsAPSetup: CustomMenuItem[];
    @Input() itemsAPInput: CustomMenuItem[];
    @Input() itemsAPProcess: CustomMenuItem[];
    @Input() itemsAPReport: CustomMenuItem[];
    @Input() itemsAPInquiry: CustomMenuItem[];

    // Menu AR
    @Input() itemsARSetup: CustomMenuItem[];
    @Input() itemsARInput: CustomMenuItem[];
    @Input() itemsARProcess: CustomMenuItem[];
    @Input() itemsARReport: CustomMenuItem[];
    @Input() itemsARInquiry: CustomMenuItem[];

    // Menu CA
    @Input() itemsCASetup: CustomMenuItem[];
    @Input() itemsCAInput: CustomMenuItem[];
    @Input() itemsCAProcess: CustomMenuItem[];
    @Input() itemsCAReport: CustomMenuItem[];
    @Input() itemsCAInquiry: CustomMenuItem[];

    // Menu FA
    @Input() itemsFASetup: CustomMenuItem[];
    @Input() itemsFAInput: CustomMenuItem[];
    @Input() itemsFAProcess: CustomMenuItem[];
    @Input() itemsFAReport: CustomMenuItem[];
    @Input() itemsFAInquiry: CustomMenuItem[];

    // Menu IN
    @Input() itemsINSetup: CustomMenuItem[];
    @Input() itemsINInput: CustomMenuItem[];
    @Input() itemsINProcess: CustomMenuItem[];
    @Input() itemsINReport: CustomMenuItem[];

    // Menu SA
    @Input() itemsSASetup: CustomMenuItem[];
    @Input() itemsSAInput: CustomMenuItem[];
    @Input() itemsSAReport: CustomMenuItem[];

    // Menu PO
    @Input() itemsPOInput: CustomMenuItem[];
    @Input() itemsPOProcess: CustomMenuItem[];
    @Input() itemsPOReport: CustomMenuItem[];

    // Menu SO
    @Input() itemsSOInput: CustomMenuItem[];
    @Input() itemsSOProcess: CustomMenuItem[];
    @Input() itemsSOReport: CustomMenuItem[];

    // Menu SI
    @Input() itemsSIInput: CustomMenuItem[];

    // Menu UF
    @Input() itemsUFInput: CustomMenuItem[];

    // Menu ST
    @Input() itemsSTInput: CustomMenuItem[];
    @Input() itemsSTSecurity: CustomMenuItem[];

    // Menu Einvoice
    @Input() itemsEISetup: CustomMenuItem[];
    @Input() itemsEIInput: CustomMenuItem[];
    @Input() itemsEIProcess: CustomMenuItem[];

    // Menu BG
    @Input() itemsBGInput: CustomMenuItem[];
    @Input() itemsBGReport: CustomMenuItem[];

    // Menu SP ApprovalSystem
    @Input() itemsSPInput: CustomMenuItem[];
    @Input() itemsSPReport: CustomMenuItem[];

    // Menu CustomerPortal
    @Input() itemsCPFinancialStatement: CustomMenuItem[];
    @Input() itemsCPCustomers: CustomMenuItem[];
    @Input() itemsCPVendors: CustomMenuItem[];
    @Input() itemsCPRevenues: CustomMenuItem[];
    @Input() itemsCPCost: CustomMenuItem[];
    @Input() itemsCPAnalyze: CustomMenuItem[];
    @Input() itemsCPManagements: CustomMenuItem[];
    @Input() itemsCPHumanResources: CustomMenuItem[];

    @Input() className: string;

    @Input() showGL: boolean;
    @Input() showAP: boolean;
    @Input() showAR: boolean;
    @Input() showCA: boolean;
    @Input() showFA: boolean;
    @Input() showIN: boolean;
    @Input() showSA: boolean;
    @Input() showSO: boolean;
    @Input() showPO: boolean;
    @Input() showEI: boolean;
    @Input() showSI: boolean;
    @Input() showST: boolean;
    @Input() showUF: boolean;
    @Input() showBG: boolean;
    @Input() showSP: boolean;
    @Input() showAS: boolean;
    @Input() showHR: boolean;
    @Input() showCP: boolean;

    @Input() files: TreeNode[];

    selectedItem: string;

    @Output() closeClicked = new EventEmitter<boolean>();

    constructor(
        private routeStateService: RouteStateService,
        private localStorageService: LocalStorageService,
        private toastService: ToastService) { }

    ngOnInit() {
        var activeMenu = this.localStorageService.getItem("active-menu");
        if (activeMenu) {
            this.selectedItem = activeMenu;
            if(this.itemsAPSetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AP";
            else if(this.itemsAPInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AP";
            else if(this.itemsAPProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AP";
            else if(this.itemsAPReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AP";
            else if(this.itemsAPInquiry.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AP";

            else if(this.itemsARSetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AR";
            else if(this.itemsARInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AR";
            else if(this.itemsARProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AR";
            else if(this.itemsARReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AR";
            else if(this.itemsARInquiry.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "AR";

            else if(this.itemsCASetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CA";
            else if(this.itemsCAInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CA";
            else if(this.itemsCAProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CA";
            else if(this.itemsCAReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CA";
            else if(this.itemsCAInquiry.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CA";

            else if(this.itemsFASetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "FA";
            else if(this.itemsFAInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "FA";
            else if(this.itemsFAProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "FA";
            else if(this.itemsFAReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "FA";
            else if(this.itemsFAInquiry.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "FA";

            else if(this.itemsINSetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "IN";
            else if(this.itemsINInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "IN";
            else if(this.itemsINProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "IN";
            else if(this.itemsINReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "IN";

            else if(this.itemsSASetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SA";
            else if(this.itemsSAInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SA";
            else if(this.itemsSAReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SA";

            else if(this.itemsPOInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "PO";
            else if(this.itemsPOProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "PO";
            else if(this.itemsPOReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "PO";

            else if(this.itemsSOInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SO";
            else if(this.itemsSOProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SO";
            else if(this.itemsSOReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SO";

            else if(this.itemsSIInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SI";

            else if(this.itemsUFInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "UF";

            else if(this.itemsSTInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "ST";
            else if(this.itemsSTSecurity.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "ST";

            else if(this.itemsEISetup.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "EI";
            else if(this.itemsEIInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "EI";
            else if(this.itemsEIProcess.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "EI";

            else if(this.itemsBGInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "BG";
            else if(this.itemsBGReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "BG";

            else if(this.itemsSPInput.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SP";
            else if(this.itemsSPReport.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "SP";

            else if(this.itemsCPFinancialStatement.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPCustomers.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPVendors.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPRevenues.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPCost.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPAnalyze.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPManagements.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";
            else if(this.itemsCPHumanResources.findIndex(w => w.Label === activeMenu) > -1 ) this.selectedTab = "CP";

            else this.selectedTab = "GL";
        } else {
            this.selectedItem = "Home";
            this.selectedTab = "GL";
        }
    }
    
    clickHR(){
        window.open('https://hr.ssaudit.com/hrweb/'); 
    }

    clickCP(){
        window.open('https://smartbooks.ssaudit.com/cp-demo/'); 
    }
    clickAS(){
        window.open('https://smartbooks.ssaudit.com/cp-demo/approval.php'); 
    }
    // on menu click event
    onMenuClick(menu: CustomMenuItem) {
        // if child are available then open child
        if (menu.Childs != undefined || menu.Childs != null) {
            this.toggleSubMenu(menu);
            return;
        }
        if (menu.RouterLink == undefined || menu.RouterLink == null || menu.RouterLink == "") {
            this.toastService.addSingle("error", "", "404 Page not found.");
            return;
        }
        this.selectedItem = menu.Label;
        this.localStorageService.setItem("active-menu", menu.Label);
        this.routeStateService.add(menu.Label, menu.RouterLink, null, true);
        // hide menu bar after menu click for mobile layout        
        setTimeout(() => {
            this.closeClicked.emit(false);
        }, 100);
    }

    // toggle sub menu on click
    toggleSubMenu(menu: CustomMenuItem) {
        menu.IsChildVisible = !menu.IsChildVisible;
    }

}
